var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYanlis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 110,
    fill: "#FFFFFF",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 96,
    fill: "#FFFFFF",
    opacity: 0.14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 82,
    fill: "#FFFFFF",
    opacity: 0.24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 70,
    fill: "#FFFFFF",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 62,
    fill: "#FFFFFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 42,
    fill: "#E24A44"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 102,
    x2: 138,
    y2: 138,
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: 102,
    x2: 102,
    y2: 138,
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYanlis);
export default __webpack_public_path__ + "static/media/yanlis.ae1431766bb634415d7dc8b10a1336a5.svg";
export { ForwardRef as ReactComponent };